<template>
    <div class="fabric-in">
        <div class="main-body">
            <Icon class="close-ico" type="md-close" @click="onClose" />
            <div class="main-header">{{material.type == 1 ? '面料' : '辅料'}}入仓</div>
            <div class="main-body-form">
                <div class="top-info">
                    <div class="left-item">
                        <div class="title">{{material.type == 1 ? '面料' : '辅料'}}信息</div>
                        <div class="info">
                            <img :src="material.image|default_img" alt="" class="fabric-cover" />
                            <div class="fabric-info">
                                <div class="fabric-name">{{material.name}}</div>
                                <div class="info-item">编号:{{material.no}}</div>
                                <div class="info-item">成分:{{material.component}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="right-item">
                        <div class="title">工厂仓库收货地址</div>
                        <div class="address-info">
                            <div class="recive-ico">收</div>
                            <div class="address-info-item">
                                <div class="name-row">
                                    <div class="name">{{setting.contact_person}}</div>
                                    <div class="copy-btn" @click="onCopyAddress">复制</div>
                                </div>
                                <div class="phone-row">{{setting.contact_mobile}}</div>
                                <div class="address-row" :title="setting.contact_address">{{setting.contact_address}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title">入仓详情</div>
                <div class="form-body">
                    <div class="form-item form-col-3">
                        <div class="form-item-label required">物流公司</div>
                        <div class="form-item-value-single">
                            <Select placeholder="请选择物流公司" v-model="form.logistics_company">
                                <Option v-for="(item,index) in logistics_company_list" :key="`logistics-company-${index}`" :label="item.name" :value="item.id" />
                            </Select>
                        </div>
                    </div>
                    <div class="form-item form-col-3">
                        <div class="form-item-label required">运单号</div>
                        <div class="form-item-value-single">
                            <Input placeholder="请输入运单号" v-model="form.logistics_no" />
                        </div>
                    </div>
                    <div class="form-item form-col-3">
                        <div class="form-item-label required">寄出时间</div>
                        <div class="form-item-value-single">
                            <DatePicker  placeholder="年-月-日" type="date" style="width:100%;" v-model="form.send_time" />
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-label required">入仓颜色及数量</div>
                        <div class="form-item-value-multiple">
                            <div class="value-item" v-for="(item,index) in form.wuliao_json" :key="`value-item-${index}`">
                                <div class="item-left">
                                    <img :src="item.image|default_img" alt="" class="color-img" />
                                    <div class="color-name">{{item.name}}</div>
                                </div>
                                <div class="item-right">
                                    <input type="text" v-model="item.send" placeholder="入仓数量" />
                                    <div class="input-unit">m</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-label">备注信息</div>
                        <div class="form-item-value-single">
                            <Input placeholder="请输入备注信息" v-model="form.memo" type="textarea" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-footer">
                <div class="cancel-btn" @click="onClose">取消</div>
                <div class="confirm-btn" @click="onSubmit">确认入库</div>
            </div>
        </div>
    </div>
</template>
<script>
import { logisticsCompanyList, OwnerMaterialSendBack } from "@/api/index";
import { mapState } from 'vuex';
export default{
    name:"FabricIn",
    props:{
        material:{
            type:Object,
            default:()=>({})
        }
    },
    computed:{
        ...mapState({
            setting:(state)=>state.setting
        })
    },
    data(){
        return{
            form:{},
            logistics_company_list:[]
        }
    },
    mounted(){
        this.onGetLogisticsCompanyList();
        console.log('setting',this.setting);
        if(!this.material.uuid){
            this.$layer.msg('物料不存在~');
            this.onClose();
            return;
        }
        this.form.uuid = this.material.uuid;
        if(this.material.color.length){
            this.form.wuliao_json = this.material.color.map((item)=>{
                return {color_id:item.id,send:0,image:item.image,name:item.name};
            });
        }
    },
    methods:{
        async onSubmit(){
            try{
                console.log('material-in-submit',this.form);
                const {code,msg} = await OwnerMaterialSendBack(this.form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.onClose();
            }catch(e){
                console.log('err-submit',e);
                this.$layer.msg(e.msg);
            }
        },
        onCopyAddress(){
            const {contact_person,contact_mobile,contact_address} = this.setting;
            const text = `姓名:${contact_person}\n手机:${contact_mobile}\n地址:${contact_address}`;
            navigator.clipboard.writeText(text).then(()=>{
                this.$layer.msg('复制成功~');
            }).catch(e=>{
                console.log('err-cp',e);
                this.$layer.msg('复制失败~');
            });
        },
        async onGetLogisticsCompanyList(){
            try{
                const {code,msg,data} = await logisticsCompanyList();
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('logistics-company-list',data);
                this.logistics_company_list = data;
            }catch(e){
                console.log('err-logistics-company-list',e);
            }

        },
        onClose(){
            this.$emit("close")
        }
    }
}
</script>
<style lang="scss" scoped>
.fabric-in{ 
    position:fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,.5);
    z-index:110;
    display:flex;
    align-items:center;
    justify-content:center;
    .main-body{
        width:920px;
        background:#fff;
        border-radius:10px;
        display:flex;
        flex-direction:column;
        position:relative;
        .close-ico{
            position:absolute;
            top:14px;
            right:16px;
            font-size:18px;
            cursor:pointer;
        }
        .main-header{
            width:100%;
            border-bottom:1px solid #e0e0e0;
            padding-bottom:12px;
            padding-top:20px;
            text-align:center;
            font-size:20px;
            font-weight:bold;
            color:#0f1115;
            margin-bottom:20px;
        }
        .main-body-form{
            width:100%;
            padding:0 24px;
            .top-info{
                display:flex;
                justify-content:space-between;
                align-items:center;
                column-gap:20px;
                margin-bottom:24px;
                .left-item{
                    display:flex;
                    flex-direction:column;
                    row-gap:12px;
                    flex:0 0 calc(50% - 10px);
                    .title{
                        color:#333;
                        font-size:16px;
                        font-weight:bold;
                    }
                    .info{
                        border:1px solid #e3e3e3;
                        border-radius:6px;
                        display:flex;
                        column-gap:16px;
                        width:100%;
                        padding:10px;
                        .fabric-cover{
                            width:96px;
                            height:96px;
                            border:1px solid #e3e3e3;
                            border-radius:8px;
                        }
                        .fabric-info{
                            display:flex;
                            flex-direction:column;
                            align-items:flex-start;
                            justify-content:center;
                            .fabric-name{
                                font-size:14px;
                                color:#333;
                                font-weight:bold;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                margin-bottom:10px;
                            }
                            .info-item{
                                color:#666;
                                font-size:14px;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                            }
                        }
                    }
                }
                .right-item{
                    display:flex;
                    flex-direction:column;
                    row-gap:12px;
                    flex:0 0 calc(50% - 10px);
                    .title{
                        color:#333;
                        font-size:16px;
                        font-weight:bold;
                        padding-left:10px;
                    }
                    .address-info{
                        width:100%;
                        border:1px solid #e3e3e3;
                        border-radius:6px;
                        padding:25px 18px;
                        display:flex;
                        align-items:flex-start;
                        column-gap:12px;
                        .recive-ico{
                            font-size:12px;
                            padding:0 4px;
                            background:#ff5067;
                            color:#fff;
                            border-radius:4px;
                        }
                        .address-info-item{ 
                            display:flex;
                            flex-direction:column;
                            row-gap:3px;
                            width:100%;
                            .name-row{
                                display:flex;
                                align-items:center;
                                justify-content:space-between;
                                .name{
                                    color:#333;
                                    font-size:14px;
                                }
                                .copy-btn{
                                    font-size:12px;
                                    color:#0066ff;
                                    cursor:pointer;
                                }
                            }
                            .phone-row{
                                color:#333;
                                font-size:14px;
                            }
                            .address-row{
                                color:#666;
                                font-size:12px;
                            }
                        }
                    }
                }
            }
            .title{
                width:100%;
                font-weight:bold;
                color:#333;
                font-size:16px;
                margin-bottom:12px;
            }
            .form-body{
                width:100%;
                background:#f6f7f9;
                border-radius:6px;
                padding:16px 18px 22px 18px;
                display:flex;
                flex-wrap:wrap;
                column-gap:13px;
                row-gap:24px;
                margin-bottom:50px;
                .form-item{
                    display:flex;
                    flex-direction:column;
                    row-gap:10px;
                    width:100%;
                    &.form-col-3{
                        width:calc(100% / 3 - 13px);
                    }
                    .form-item-label{
                        color:#333;
                        font-size:14px;
                        &.required::after{
                            content:"*";
                            color:red;
                        }
                    }
                    .form-item-value-single{
                        width:100%;
                    }
                    .form-item-value-multiple{
                        display:flex;
                        flex-wrap:wrap;
                        gap:13px;
                        .value-item{
                            width:calc(100% / 3 - 13px);
                            display:flex;
                            align-items:center;
                            border:1px solid #e3e3e3;
                            border-radius:4px;
                            background:#fff;
                            .item-left{
                                display:flex;
                                align-items:center;
                                column-gap:7px;
                                border-right:1px solid #e3e3e3;
                                padding:5px;
                                width:50%;
                                .color-img{
                                    width:32px;
                                    height:32px;
                                    border:1px solid #e3e3e3;
                                    border-radius:4px;
                                }
                                .color-name{
                                    color:#333;
                                    font-size:14px;
                                    white-space:nowrap;
                                    text-overflow:ellipsis;
                                    overflow:hidden;
                                }
                            }
                            .item-right{
                                display:flex;
                                align-items:center;
                                padding:0 10px;
                                width:50%;
                                input{
                                    border:none;
                                    outline:none;
                                    width:90%;
                                }
                                .input-unit{
                                    color:#333;
                                    font-size:14px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .main-footer{
            width:100%;
            border-top:1px solid #e0e0e0;
            display:flex;
            align-items:center;
            justify-content:center;
            column-gap:10px;
            padding-top:18px;
            padding-bottom:22px;
            .cancel-btn{
                color:#666;
                font-size:14px;
                font-weight:bold;
                cursor:pointer;
                height:40px;
                line-height:40px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                padding:0 36px;
            }
            .confirm-btn{
                color:#fff;
                font-size:14px;
                font-weight:bold;
                cursor:pointer;
                height:40px;
                line-height:40px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                padding:0 40px;
                background:#ff5967;
            }
        }
    }
}
</style>